module.exports = __webpack_public_path__ + "img/flowchart_mercados_y_empresas_1.d23097e5.svg";